<template>
  <!-- Content Starts -->
  <div class="row">
    <div class="col-md-12">
      <div class="card mb-0">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped table-nowrap custom-table mb-0 datatable" id="dkl-table">
              <thead>
              <tr>
                <th data-orderable="false" class="select-all-checkbox"></th>
                <th data-orderable="false">Actions</th>
                <th v-for="column in headers">
                  <div style="white-space: nowrap">
                    {{column.label}}
                  </div>
                </th>
              </tr>
              <tr class="filters">
                <th class="dtfc-fixed-left filter-checkbox" style="position: sticky"></th>
                <th class="dtfc-fixed-left filter-action" style="position: sticky"></th>
                <th v-for="(column, index) in headers" :class="'filter'+index" :style="[0, 1].includes(index) ? 'position: sticky;' : ''">
                  <input v-if="column.style=='text-input'" type="text" class="form-control input-sm" style="height: 30px !important;" :placeholder="column.label" :data-column-index="index">
                  <select v-else-if="column.style=='dropdown'" class="form-control dkl-status-select" style="height: 30px!important;"></select>
                  <div v-else v-html="column.style"></div>
                </th>
              </tr>
              </thead>
              <tbody>
              </tbody>
            </table>
            <a class="button btn-shown-hover btn-shown-right" href="#" @click.prevent="moveRight"><i class="fa fa-angle-double-right" style="font-size: 60px; font-weight: 900; color: rgba(155, 49, 54, 0.6)" id="next_content"></i></a>
            <a class="button btn-shown-hover btn-shown-left" href="#" @click.prevent="moveLeft"><i class="fa fa-angle-double-left" style="font-size: 60px; font-weight: 900; color: rgba(155, 49, 54, 0.6)" id="prev_content"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Content End -->
</template>
<script>
  import {service, baseURL} from '@/utils/request.js';
  import {mapState} from 'vuex';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import { Uploader, Button } from 'vant';

  export default {
    components: {'van-uploader': Uploader, 'van-button': Button, datePicker},
    props: {
      editorCallback: {
        type: Boolean,
        default: false
      },
      allowDelete: {
        type: Boolean,
        default: true
      },
      allowEdit: {
        type: Boolean,
        default: true
      },
      allowEditAction: {
        type: Boolean,
        default: true
      },
      allowDeleteAction: {
        type: Boolean,
        default: true
      },
      exportHidden: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'dkl-title',
      },
      fileName: {
        type: String,
        default: 'dkl-filename',
      },
      modelName: {
        type: String,
        default: 'vt',
      },
      deleteURL: {
        type: String,
        required: true,
      },
      extraActions: {
        type: Function,
        default: () => '',
      },
      editorPatchURL: {
        type: String,
        required: true,
      },
      editorRefreshFields: {
        type: Array,
        default: () => ['systems', 'system']
      },
      columns: {
        type: Array,
        required: true
      },
      objects: {
        type: Array,
        default: () => []
      },
      exportColumns: {
        type: Array,
        default: [0, 1, 7]
      },
      extraExportButtons: {
        type: Array,
        default: () => []
      },
      newObject: {
        type: Object,
        default: () => {
          return {
            id: null,
              customer: '',
              system: null,
              system_id: null,
              affected_person: [],
              data_type: [],
              comments: [],
              attachments: [],
              tasks: [],
              modified_by: null,
              added: '',
              modified: '',
              name: '',
              description: null,
              purpose: '',
              process_type: '',
              data_origin: '',
              person_informed: false,
              person_informed_remarks: null,
              legal_base: '',
              data_protection: '',
              responsible_person: '',
              process_place: '',
              access_rights: '',
              storage_duration: '',
              intern_receipt: '',
              extern_receipt: '',
              data_transfer: false,
              data_transfer_remarks: null,
              profiling: false,
              profiling_remarks: null,
              evaluation: false,
              evaluation_remarks: null,
              document: null,
              storage_place: null,
              stand: null,
              departments: []
          }
        }
      },
      currentObject: {
        type: Object,
        default: () => {}
      },
      drawCallbackFunctions: {
        type: Function,
        default: () => {}
      },
      editorOnCallback: {
        type: Function,
        default: () => {}
      },
      initCallbackFunctions: {
        type: Function,
        default: () => {}
      },
      departments: {
        type: Array,
        default: () => []
      },
      systems: {
        type: Array,
        default: () => []
      },
      dataTypes: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        datetimeOptions: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        },
        windowHeight: window.innerHeight,
        enDatatable: require('@/assets/i18n/datatables/en-GB.json'),
        deDatatable: require('@/assets/i18n/datatables/de-DE.json')
      }
    },
    created() {
    },
    async mounted() {
      /*tabs*/
      window.addEventListener('resize', this.onResize);

      await this.initTable()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    },
    computed: {
      ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, language: state => state.app.language}),
      exportOptions() {
        return {
          columns: (idx, data, node) => {
            if (this.exportHidden) {
              return !this.exportColumns.includes(idx)
            }
            return !this.exportColumns.includes(idx) && $('.datatable').DataTable().column(idx).visible()
          },
          format: {
            // body: (data, row, column, node) => {
            //   return column === 12 ? '' : data
            // },
            header: (data, columnIdx) => {
              if (!this.exportColumns.includes(columnIdx)) return this.headers[columnIdx-2].label
              return ''
            },
          }
        }
      },
      currentDateString() {
        return new Date().toLocaleDateString()
      },
      exportButtons() {
        const defaultButtons = [
          {extend: 'csv', exportOptions: this.exportOptions, title: `${this.title} - ${this.currentDateString} – ${this.account.name}`, filename: `${this.fileName}_DSMS_am_${this.currentDateString}_${this.account.name}`},
          {
            extend: 'excel',
            exportOptions: this.exportOptions,
            title: `${this.title} - ${this.currentDateString} – ${this.account.name}`,
            filename: `${this.fileName}_DSMS_am_${this.currentDateString}_${this.account.name}`,
            orientation: 'landscape',
            customize: function(xlsx) {
              const sheet = xlsx.xl.worksheets['sheet1.xml'];
              // const col = $('col', sheet);
              // set the column width otherwise it will be the length of the line without the newlines
              // $(col[3]).attr('width', 50);
              $('row c', sheet).each(function() {
                if ($(this).attr('r').charAt(0) === 'A') $(this).attr('s', '7')
                if ($(this).text() && $(this).text().length > 58) {
                  // https://datatables.net/reference/button/excelHtml5#Built-in-styles All buildin styles
                  $(this).attr('s', '55');
                  //change the type to `str` which is a formula
                  // $(this).attr('t', 'str');
                  //append the concat formula
                  // $(this).append('<f>' + $('is t', this).text() + '</f>');
                  //remove the inlineStr
                  // $('is', this).remove();
                }
              })
              // const col = $('col:A c', sheet);
              return xlsx
            }
          },
        ]
        if (this.extraExportButtons.length === 0) return [...defaultButtons, {extend: 'pdf', exportOptions: this.exportOptions, title: `${this.title} - ${this.currentDateString} – ${this.account.name}`, filename: `${this.fileName}_DSMS_am_${this.currentDateString}_${this.account.name}`, orientation: 'landscape', customize: (doc) => {
          let colDef = [];
          $('#dkl-table').find('tbody tr:first-child td').each(function(){
            if($(this).attr('colspan')){
              for(let i=1;i<=$(this).attr('colspan');i++){
                colDef.push('*');
              }
            }else{ colDef.push('*'); }
          });
          doc.content[1].table.widths = colDef;
          }}]
        return defaultButtons.concat(this.extraExportButtons)
      },
      defaultColumnDefinitions() {
        const checkboxColumn = {data: null, render: data => '', className: 'select-checkbox',  orderable: false}
        const actionColumn = { data: null, render: (data) => {
          const editAction = this.allowEdit ? `<a class="dropdown-item edit-object" data-object-id="${data.id}" href="#">Eintrag bearbeiten</a>` : ''
          const deleteAction = this.allowDelete ? `<a class="dropdown-item delete-object" href="#" data-object-id="${data.id}">Eintrag löschen</a>` : ''
          var return_html = `
              <div class="dropdown dropdown-action">
                  <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
                  <div class="dropdown-menu dropdown-menu-right">
                      ${this.allowEditAction ? editAction : ''}
                      ${this.allowDeleteAction ? deleteAction : ''}
                      ${this.extraActions(data)}
                  </div>
              </div>
              `;
          return return_html
        }, width: '50px'}
        return [checkboxColumn, actionColumn, ...this.columnDefinitions]
      },
      columnDefinitions() {
        const columnDefinitions = []
        this.columns.forEach((column, i) => {
          if (column.definition) {
            if (!column.enableEditor) {
              columnDefinitions.push({...column.definition, className: 'className' in column.definition ? column.definition.className + ' disable-editor' : 'disable-editor'})
            } else {
              columnDefinitions.push(column.definition)
            }
          }
        })
        return columnDefinitions
      },
      headers() {
        const headers = []
        this.columns.forEach(column => {
          if (column.definition) {
            if (column.filterStyle) {
              headers.push({label: column.label, style: column.filterStyle})
            } else {
              headers.push({label: column.label, style: 'text-input'})
            }
          }
        })
        return headers
      },
      editorColumns() {
        const editorColumns = []
        this.columns.forEach(column => {
          if (column.enableEditor) editorColumns.push(column)
        })
        return editorColumns
      },
    },
    updated ()
    {

      // Date Time Picker

      if ($('.datetimepicker').length > 0) {
        $('.datetimepicker').datetimepicker({
          format: 'DD/MM/YYYY',
          icons: {
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            next: 'fa fa-angle-right',
            previous: 'fa fa-angle-left'
          }
        });
      }
    },
    methods: {
      onResize() {
        this.windowHeight = window.innerHeight
      },
      moveRight() {
        $('.dataTables_scrollBody').animate({
          scrollLeft: '+=500px'
        }, 500)
      },
      moveLeft() {
        $('.dataTables_scrollBody').animate({
          scrollLeft: '-=500px'
        }, 500)
      },
      toggle_column(event, column_index) {
        // Get the column API object
        let column = $('.datatable').DataTable().column(column_index);

        // Toggle the visibility
        column.visible(!column.visible());

        // adjust dropdown menu
        if (column.visible() && !$(event.target).hasClass('selected')) {
          $(event.target).addClass('selected')
        } else if (!column.visible() && $(event.target).hasClass('selected')) {
          $(event.target).removeClass('selected');
        }
      },
      close_help() {
        $('#modal-help').hide()
      },
      async initTable() {
        const that = this
        const dtLanguage = this.language === 'de' ? this.deDatatable : this.enDatatable;
        const editor = new $.fn.dataTable.Editor({
          ajax:  {
            edit: ( method, url, data, success, error ) => {
              let item = {}
              for (const [key, value] of Object.entries(data.data)) {
                item['id'] = parseInt(key)
                for (const [itemKey, itemValue] of Object.entries(value)) {
                  item[itemKey] = itemValue
                }
                item.modified_by = this.userName
                item.customer = this.account.name
              }
              service.request({
                url: `${this.editorPatchURL}${item.id}/`,
                method: 'PUT',
                responseType: 'json',
                data: item
              }).then((response) => {
                let updatedObj = response.data
                if (updatedObj === 'offline') {
                  updatedObj = this.objects.filter(obj => obj.id === item.id)[0]
                  for (const [objKey, objValue] of Object.entries(item)) {
                    if (objKey !== 'id' && objKey !== 'customer') {
                      updatedObj[objKey] = objValue
                    }
                  }
                }
                if (this.editorCallback) {
                  this.$emit('editorUpdated', updatedObj)
                } else {
                  const objectIndex = this.objects.findIndex(obj => obj.id === updatedObj.id)
                  this.objects[objectIndex] = updatedObj
                  $('#dkl-table').DataTable().clear().rows.add(this.objects).draw(false)
                }
                editor.display(false)
                success(updatedObj)
              }).catch((err) => {
                console.log(err)
                editor.error(err.toString())
                error(err)
              })
            }
          },
          table: '#dkl-table',
          idSrc:  'id',
          fields: this.editorColumns
        } );
        // Activate an inline edit on click of a table cell
        $('#dkl-table').off('click').on( 'click', 'tbody td:not(:first-child)', function (e) {
          e.preventDefault();
          let target = e.target
          if (!$(target).is('td')) {
            target =  $(e.target).closest('td')
          }
          if (
            !$(e.target).closest('td').hasClass('disable-editor') &&
            //!$(e.target).hasClass('fa-pencil') &&
            !$(e.target).hasClass('related-system') &&
            !$(e.target).hasClass('related-supplier') &&
            !$(e.target).hasClass('related-risk') &&
            !$(e.target).closest('a').hasClass('related-risk') &&
            !$(e.target).hasClass('fa-plus') &&
            !$(e.target).hasClass('stretched-link') &&
            !$(e.target).hasClass('pipeline-project') &&
            !$(e.target).hasClass('planing') &&
            !$(e.target).hasClass('dkl-task') &&
            ($(e.target).parents('.dkl-task').length === 0) &&
            !$(e.target).closest('td').hasClass('dtfc-fixed-left')) {
            editor.bubble( target, {scope: 'cell'} );
          }
          // editor.edit( this, {
          //   submit: 'changed'
          // } );
        } );
        editor.on('open', (e, mode, action) => {
          that.editorOnCallback(e, mode, action)
        })
        // editor.on('preSubmit', (e, data, action) => {
        //   console.log(data)
        //   if (action === 'edit') {
        //     const editedData = []
        //     let item = {}
        //     for (const [key, value] of Object.entries(data.data)) {
        //       item['id'] = key
        //       for (const [itemKey, itemValue] of Object.entries(value)) {
        //         item[itemKey] = itemValue
        //       }
        //       item.modified_by = this.userID
        //       editedData.push(item)
        //     }
        //     data.data = editedData
        //     return true
        //   }
        //   return true
        // })
        const scrollHeight = this.windowHeight - 300
        let pageScrollPos = null
        const table = $('#dkl-table').DataTable({
          "data": this.objects,
          "language": dtLanguage,
          responsive: {
            breakpoints: [
              { name: 'desktop', width: Infinity }, // >= 600px: no responsive behavior needed
              { name: 'mobile',  width: 768 }       // < 600px: responsive can activate
            ]
          },
          lengthMenu: [
            [25, 50,-1],
            [25, 50, 'Alle'],
          ],
          "pageLength": -1,
          orderCellsTop: true,
          // autoWidth: false,
          "preDrawCallback": function (settings) {
            pageScrollPos = $('div .dataTables_scrollBody').scrollTop();
          },
          drawCallback: function () {
            $('div .dataTables_scrollBody').scrollTop(pageScrollPos);
            $('.t-dot').tooltip({ template: '<div class="tooltip status" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>', html: true })
            $('.select-checkbox').off('click').on('click', (e) => {
              e.preventDefault();
              const headerTR = $('th.select-all-checkbox').closest('tr')
              const table = this.api().table()
              const tr = $(e.target).closest('tr')
              if (tr.hasClass('selected')) table.row(tr).deselect()
              else table.row(tr).select()
              if (table.rows({selected: true}).count() === table.rows().count() && !headerTR.hasClass('selected')) {
                headerTR.removeClass('partial-selected')
                headerTR.addClass('selected')
              }
              if (table.rows({selected: true}).count() < table.rows().count() && table.rows({selected: true}).count() > 0 && !headerTR.hasClass('partial-selected')) {
                headerTR.removeClass('selected')
                headerTR.addClass('partial-selected')
              }
              if (table.rows({selected: true}).count() === 0) {
                headerTR.removeClass('selected')
                headerTR.removeClass('partial-selected')
              }
            })
            $('.select-all-checkbox').off('click').on('click', (e) => {
              e.preventDefault();
              const table = this.api().table()
              const tr = $(e.target).closest('tr')
              if (tr.hasClass('selected')) {
                table.rows().deselect()
                tr.removeClass('selected')
                tr.removeClass('partial-selected')
              }
              else {
                table.rows().select()
                tr.removeClass('partial-selected')
                tr.addClass('selected')
              }
            })
            $('.delete-object').off('click').on('click', function(e) {
              e.preventDefault()
              const objectID = $(e.target).data('object-id');
              const objectIndex = that.objects.map(e=>e.id).indexOf(objectID)
              that.$confirm(
                {
                  message: `Sicher, dass diese ${that.title} gelöscht wird?`,
                  button: {
                    no: 'Nein',
                    yes: 'Ja'
                  },
                  callback: confirm => {
                    if (confirm) {
                      service.request({
                        url: `${that.deleteURL}${objectID}/`,
                        method: 'DELETE',
                        responseType: 'json'
                      }).then(function(res) {
                        if (objectIndex > -1) {
                          const sequence = that.objects.filter(item => item.id === objectID)[0].sequence
                          that.objects.splice(objectIndex, 1)
                          that.objects = that.objects.map(item => {
                            if (item.sequence > sequence) item.sequence = item.sequence - 1
                            return item
                          })
                          $('.datatable').DataTable().clear().rows.add(that.objects).draw()
                        }
                        that.$vToastify.success(`${that.title} ist erfolgreich gelöscht!`)
                      })
                    }
                  }
                }
              )
            })
            $('.edit-object').off('click').on('click', function(e) {
              e.preventDefault();
              const objectID = $(e.target).data('object-id')
              that.$emit('showObject', objectID)
            })
            $(window).off('show.bs.dropdown').on('show.bs.dropdown', (e) => {
              const dropdownParent = $(e.target).parent('td.text-wrap')
              if (dropdownParent.css('position') == 'sticky') dropdownParent.css('z-index', '10')
            })
            $(window).off('hide.bs.dropdown').on('hide.bs.dropdown', (e) => {
              const dropdownParent = $(e.target).parent('td.text-wrap')
              if (dropdownParent.css('z-index') == 10) dropdownParent.css('z-index', '1')
            })
            that.$emit('callDrawback')
          },
          // fixedHeader: true,
          initComplete: function () {
            $('.filter-checkbox').css('left', $('.filter-checkbox').first().position().left)
            $('.filter-action').css('left', $('.filter-action').first().position().left)
            $('.filter0').css('left', $('.filter0').first().position().left)
            $('.filter1').css('left', $('.filter1').first().position().left)
            const api = this.api();
            let cursorPosition = null;
            // For each column
            api
              .columns()
              .eq(0)
              .each(function (colIdx) {
                // Set the header cell to contain the input element
                // const cell = $('.filters input').eq(
                //   $(api.column(colIdx).header()).index()
                // );
                const cell = $(`.table-responsive .filter${colIdx - 2} .form-control`)
                // On every keypress in this input
                if (cell.length) {
                  if (cell[0].nodeName === 'INPUT') {
                    // console.log(colIdx)
                    // console.log('input')
                    cell
                      .off('keyup change')
                      .on('change', function (e) {
                        e.stopPropagation();
                        // Get the search value
                        $(this).attr('title', $(this).val());
                        const regexr = '({search})'; //$(this).parents('th').find('select').val();
                        // Search the column for that value
                        cursorPosition = this.selectionStart;
                        api
                          .column(colIdx)
                          .search(
                            this.value != ''
                              ? regexr.replace('{search}', '(((' + this.value + ')))')
                              : '',
                            this.value != '',
                            this.value == ''
                          )
                          .draw();
                      }).on('keyup', function (e) {
                      e.stopPropagation();
                      $(this).trigger('change');
                      $(this)
                        .focus()[0]
                        .setSelectionRange(cursorPosition, cursorPosition);
                    });
                  } else if (cell[0].nodeName === 'SELECT') {
                    // console.log('SELECT')
                    cell.append(new Option('-----', 'all'))
                    api.cells('', colIdx)
                      .render('display')
                      .unique()
                      .each(function (d, j) {
                        let strOption = d.replace(/<\/?[^>]+(>|$)/g, "")
                        cell.append(new Option(strOption, strOption));
                      });
                    cell.on('change', function () {
                      let selectedValue = $(this).val()
                      let val = DataTable.util.escapeRegex(selectedValue);
                      api.column(colIdx)
                        .search(val !== 'all' ? selectedValue : '', val !== 'all', val === 'all')
                        .draw();
                    });
                    // cell.val('offen').trigger('change')
                  }
                }
              });
            that.initCallbackFunctions(api)
          },
          "columns": this.defaultColumnDefinitions,
          columnDefs: [
            {className: "text-wrap", targets: "_all"},
            {defaultContent: "-", targets: "_all"},
            {width: "50px", targets: 0},
            {width: "50px", targets: 1},
          ],
          order: [[2, 'asc']],
          fixedColumns:   {
            left: 4
          },
          select: {
            style: 'api',
          },
          rowReorder: {
            dataSrc: 'sequence',
            // editor:  that.editor,
            selector: '.dkl-vt-sequence'
          },
          buttons: this.exportButtons,
          dom: 'Bfrtilp',
          scrollX: true,
          scrollY: scrollHeight,
          scrollCollapse: true,
          retrieve: true,
        });

        table.on('row-reorder', (e, diff, edit) => {
          let rowData = {}
          const changedData = []
          diff.forEach(item => {
            rowData = table.row(item.node).data();
            changedData.push({id: rowData.id, sequence: item.newData});
          })
          service.request({
            url: 'todos/v1/update_sequence/',
            method: 'POST',
            responseType: 'json',
            data: {model: this.modelName, data: changedData}
          }).catch(function(err) {
            console.log(err)
          })
        })
        this.$emit('tableCreated', table)
        this.$emit('editorCreated', editor)
      },
    }
  }
</script>
<style scoped>
  .modal:nth-of-type(even) {
    z-index: 1050 !important;
  }
  .modal:nth-of-type(odd) {
    z-index: 1052 !important;
  }
  /*.modal-backdrop.show:nth-of-type(even) {*/
    /*z-index: 1051 !important;*/
  /*}*/
  .dkl-title-h4 {
    background-color: #f3f1f1;
    align-items: center;
  }
  .strikethrough {
    text-decoration: line-through;
  }
  .dkl-bg-offen, .dkl-bg-prioa {
    color: #ff0000;
  }
  .dkl-bg-abgeschlossen, .dkl-bg-prioc {
    color: #009900;
  }
  .dkl-bg-priob {
    color: orange;
  }
  .dkl-span-new-line {
    display: block;
  }
  .btn-shown-hover {
    display: none;
    position: absolute;
    top: 40%;
  }

  .z-index-0 {
    z-index: 0!important;
  }

  .btn-shown-right {
    right: 20px;
  }

  .btn-shown-left {
    left: 20px;
    z-index: 2;
  }

  .table-responsive:hover .btn-shown-hover, .btn-shown-hover:hover {
    display: inline-block;
  }

  .select2-results__option[aria-selected=true] { display: none;}

  .info-popup {
    display: none;
    position: absolute;
    color: #333333;
    padding: 5px;
    border: solid 1px #ddd;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    text-align: center;
    width: 10%;
  }

  #dkl-table {
    min-height: 150px;
  }

</style>
